import equalHeight from '../../equalHeight';
import '../../../libraries/imagesloaded.pkgd.min';

export default function viewMode() {
  equalHeight();
  $('.view-mode span[data-attr]').on('click', function (event) {
    event.preventDefault();
    var dataAttrViewMode = $(this).attr("data-attr");
    $('.view-mode li').removeClass('view-mode-active');
    $(this).parent('li').addClass('view-mode-active');
    $.cookie('viewMode', dataAttrViewMode, { expires: 365, path: "/" });
    var $tabContent = $(this).parents('.tab-panel').siblings('.tab-content');
    $tabContent.find('.product-list-container').removeClass('grid-view list-view table-view').addClass(dataAttrViewMode);
    
    if ($(".grid-view").is(":visible")) {
      $('.grid-view').imagesLoaded().always(function () {
        equalHeight('.grid-view .product-list-holder .product_item-img');
        equalHeight('.grid-view .product-list-holder .title');
      });
    }

    $(".product_item .description").each(function () {
      if ($(this).text().length > 199) {
        $(this).text($(this).text().substring(0, 199) + '...');
      }
    });
  });
}